import { render, staticRenderFns } from "./YOMCharts.vue?vue&type=template&id=3134eec1&scoped=true"
import script from "./YOMCharts.vue?vue&type=script&lang=js"
export * from "./YOMCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3134eec1",
  null
  
)

export default component.exports